<div class="w-full max-w-3xl">
    <div class="prose prose-sm !max-w-100 col-span-4 mb-[20px]">
        <h2>Skrá skjal</h2>
    </div>
    <mat-tab-group
        class="sm:px-2 hjalp-tab-group fade-in-left"
        [animationDuration]="'0'"
        [selectedIndex]="selectedTabIndex"
        (selectedTabChange)="tabChanged($event)"
    >
        <mat-tab label="Stakt skjal">
            <app-documents-add-single></app-documents-add-single>
        </mat-tab>
        <mat-tab label="Bunkaskráning">
            <app-documents-add-multiple></app-documents-add-multiple>
        </mat-tab>
    </mat-tab-group>
</div>
